module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playout-load-dashboard"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.average) ? _c('div', {
    staticClass: "metric-text"
  }, [_c('span', {
    staticClass: "metric-text-title"
  }, [_vm._v("Average:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(Math.round(_vm.average)) + " minutes per hour")])]) : _vm._e(), _vm._v(" "), (_vm.max) ? _c('div', {
    staticClass: "metric-text"
  }, [_c('span', {
    staticClass: "metric-text-title"
  }, [_vm._v("Maximum:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.max.value) + " minutes, on " + _vm._s(_vm.max.date))])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('line-chart', {
    staticClass: "chart",
    staticStyle: {
      "min-height": "380px"
    },
    attrs: {
      "showLegend": _vm.showLegend,
      "data": _vm.trendData,
      "title": _vm.title,
      "labels": _vm.labels,
      "showGridLines": _vm.showGridLines,
      "yAxeslabelString": _vm.yAxeslabelString,
      "xAxeslabelString": _vm.xAxeslabelString
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05499c92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/programmingDashboard/PlayoutLoad.vue
// module id = 3120
// module chunks = 3